import { registry } from "@web/core/registry";

export const discussComponentRegistry = registry.category("discuss.component");
